import { genreOptions, regionOptions, yearOptions } from '@/mocks/filters';

interface FilterPanelProps {
  selectedGenres: string[];
  selectedRegions: string[];
  selectedYears: number[];
  onToggleGenre: (value: string) => void;
  onToggleRegion: (value: string) => void;
  onToggleYear: (value: number) => void;
  onReset: () => void;
}

function FilterGroup<T extends string | number>({
  title,
  options,
  selected,
  onToggle,
}: {
  title: string;
  options: T[];
  selected: T[];
  onToggle: (value: T) => void;
}) {
  return (
    <div>
      <h3 className="text-sm font-semibold text-foreground-900 mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = selected.includes(option);
          return (
            <button
              key={option}
              onClick={() => onToggle(option)}
              className={`px-3 py-1.5 text-xs rounded-full border whitespace-nowrap cursor-pointer transition-colors ${
                active
                  ? 'bg-primary-500 border-primary-500 text-background-50'
                  : 'bg-background-50 border-background-300 text-foreground-600 hover:border-primary-300'
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({
  selectedGenres,
  selectedRegions,
  selectedYears,
  onToggleGenre,
  onToggleRegion,
  onToggleYear,
  onReset,
}: FilterPanelProps) {
  const hasFilter = selectedGenres.length > 0 || selectedRegions.length > 0 || selectedYears.length > 0;

  return (
    <div className="bg-background-100 rounded-lg p-5 space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-bold text-foreground-900 flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-500"></i> 筛选条件
        </h2>
        {hasFilter && (
          <button onClick={onReset} className="text-xs text-primary-600 hover:text-accent-600 cursor-pointer whitespace-nowrap">
            清空筛选
          </button>
        )}
      </div>
      <FilterGroup title="类型" options={genreOptions} selected={selectedGenres} onToggle={onToggleGenre} />
      <FilterGroup title="地区" options={regionOptions} selected={selectedRegions} onToggle={onToggleRegion} />
      <FilterGroup title="年份" options={yearOptions} selected={selectedYears} onToggle={onToggleYear} />
    </div>
  );
}